import React from 'react'
import { connect } from "react-redux";
import { colors } from '../theme';
import moment from 'moment';

const CommentComponent = ({ user, value, onChangeText, prop }) => {

  const [comment, setComment] = React.useState('');
  const [comments, setComments] = React.useState(value ? value : []);

  const changeComments = (next) => {
    setComments(next);
    if (onChangeText) onChangeText(prop, next);
  }

  const send = () => {
    if (!comment || !comment.trim()) return;
    const d = [{
      userId: user._id,
      time: new Date(),
      title: user.name + ' ' + user.surname,
      description: comment.trim(),
      lineColor: colors.primary,
    }, ...comments];
    changeComments(d);
    setComment('');
  };

  // WhatsApp-style: oldest at top, newest at the bottom, auto-scrolled to the
  // latest. Stored order is left untouched (mobile reads it) — we only sort for
  // display here.
  const scrollRef = React.useRef(null);
  const ordered = React.useMemo(
    () => [...comments].sort((a, b) => new Date(a.time) - new Date(b.time)),
    [comments]
  );
  React.useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [comments.length]);

  return (
    <div style={{ margin: '12px 0', background: 'rgba(255,255,255,0.55)', border: '1px solid rgba(15,31,46,0.08)', borderRadius: 14, padding: 14 }}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--text-muted, #8a99a8)', marginBottom: 10 }}>
        <i className="far fa-comments" style={{ color: 'var(--primary, #0DA1B2)', marginRight: 6 }}></i>
        Comments{comments.length > 0 ? ` (${comments.length})` : ''}
      </div>

      {comments.length === 0 && (
        <div style={{ fontSize: 12.5, color: 'var(--text-muted, #8a99a8)', padding: '4px 0 10px' }}>No comments yet — start the conversation below.</div>
      )}

      {comments.length > 0 && (
        <div ref={scrollRef} style={{ maxHeight: 260, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 10 }}>
          {ordered.map((rowData, k) => (
            <div key={k} style={{ background: 'rgba(255,255,255,0.85)', border: '1px solid rgba(15,31,46,0.07)', borderRadius: '12px 12px 12px 4px', padding: '8px 12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginBottom: 2 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text, #0f1f2e)' }}>{rowData.title}</span>
                <span style={{ fontSize: 11, color: 'var(--text-muted, #8a99a8)', whiteSpace: 'nowrap' }}>{moment(rowData.time).format('DD MMM HH:mm')}</span>
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-secondary, #5a6b7b)', whiteSpace: 'pre-wrap' }}>{rowData.description}</div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
        <textarea
          onChange={(v) => setComment(v.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
          value={comment}
          className="form-control"
          rows="1"
          style={{ resize: 'vertical', minHeight: 38 }}
        ></textarea>
        <button onClick={send} type="button" className="btn btn-primary" style={{ flexShrink: 0 }}>
          <i className="fas fa-paper-plane" style={{ marginRight: 6 }}></i>Send
        </button>
      </div>
    </div>
  )
}

class CommentsComponent extends React.Component {

  render() {
    return (<CommentComponent {...this.props} />);
  };
}

const mapStateToProps = state => ({
  user: state.auth.user
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentsComponent)
